"use client";
import { ToolSinglePageContext } from "@/helpers/contexts/ToolSinglePageContext";
import { ToolSinglePageProps } from "@/types/strapi/tool";
import ToolPage from "@/components/pages/tools/ToolPage";

type ToolPageWrapperProps = {
  data: ToolSinglePageProps;
};

export const ToolPageWrapper = ({ data }: ToolPageWrapperProps) => (
  <ToolSinglePageContext.Provider value={data}>
    <ToolPage />
  </ToolSinglePageContext.Provider>
);
